import { URL_LABEL } from "../../../../content/index.content";

const weeklyHotProducts = ({ language, isSavedUser }) => {
  return {
    title: "Weekly Hot Products",
    subtitle:
      "Weekly ready-to-go hot products with sales growing explosively for dozens of niches",
    href: `/app/#/reports/insights?${URL_LABEL}`,
    isBlank: true,
    isShort: true,
  };
};

export default weeklyHotProducts;
